import * as React from 'react';
import { UAParser } from 'ua-parser-js';
class UserAgent extends React.Component {
    static getUserAgent(ua) {
        const uaParser = new UAParser();
        uaParser.setUA(ua);
        const uaResults = {
            android: false,
            chrome: false,
            computer: false,
            edge: false,
            firefox: false,
            ios: false,
            linux: false,
            mac: false,
            mobile: false,
            safari: false,
            tablet: false,
            windows: false,
        };
        uaResults.android = uaParser.getOS().name === 'Android';
        uaResults.ios = uaParser.getOS().name === 'iOS';
        uaResults.mobile = uaParser.getDevice().type === 'mobile';
        uaResults.tablet = uaParser.getDevice().type === 'tablet';
        uaResults.windows = uaParser.getOS().name === 'Windows';
        uaResults.mac = uaParser.getOS().name === 'Mac OS';
        uaResults.linux = uaParser.getOS().name === 'Linux';
        uaResults.computer = uaResults.windows || uaResults.mac || uaResults.linux || uaParser.getDevice().type === undefined;
        uaResults.firefox = uaParser.getBrowser().name === 'Firefox';
        uaResults.chrome = uaParser.getBrowser().name === 'Chrome';
        uaResults.edge = uaParser.getBrowser().name === 'Edge';
        uaResults.safari = uaParser.getBrowser().name === 'Safari';
        return uaResults;
    }
    static getMatch(ua = '', target, isNot = false) {
        const current = UserAgent.getUserAgent(ua);
        const result = target.find(item => current[item] === true);
        return isNot ? !result : !!result;
    }
    constructor(props) {
        super(props);
        const { isNot, ua, target } = props;
        this.state = {
            isMatch: UserAgent.getMatch(ua, target, isNot),
            ua: ua || '',
        };
    }
    componentDidMount() {
        const { isNot, target } = this.props;
        const ua = window.navigator.userAgent;
        this.setState({
            isMatch: UserAgent.getMatch(ua, target, isNot),
            ua,
        });
    }
    componentDidUpdate(prevProps) {
        const { isNot, target } = this.props;
        if (isNot !== prevProps.isNot || target !== prevProps.target) {
            const { ua } = this.state;
            this.setState({
                isMatch: UserAgent.getMatch(ua, target, isNot),
            });
        }
    }
    render() {
        const { children } = this.props;
        const { isMatch } = this.state;
        if (!isMatch) {
            return React.createElement("div", { className: "hidden" });
        }
        return React.createElement(React.Fragment, null, children);
    }
}
UserAgent.defaultProps = {
    isNot: false,
};
export default UserAgent;
